export default "__VITE_ASSET__CDXVPX_x__"